module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews"
  }, [(_vm.list.length > 0) ? _c('reviews-short', {
    staticClass: "reviews__list",
    attrs: {
      "list": _vm.list,
      "show-avatars": _vm.avatars
    }
  }) : _vm._e(), (_vm.reviewPopup) ? _c('panel-simple', {
    staticClass: "reviews__panel",
    on: {
      "close": _vm.closePopup
    }
  }, [(_vm.showMessage) ? _c('div', {
    staticClass: "reviews__message"
  }, [(_vm.showSpinner) ? _c('app-spinner', {
    staticClass: "reviews__spinner"
  }) : _c('div', {
    staticClass: "reviews__wrap"
  }, [_c('h2', {
    staticClass: "reviews__subheader",
    class: {
      error: _vm.error
    }
  }, [_vm._v(_vm._s(_vm.error ? 'Отзыв не отправлен!' : _vm.thankText))]), _c('p', [_vm._v(_vm._s(_vm.error ? _vm.error : _vm.moderateText))])])], 1) : _vm._e(), (!_vm.showMessage) ? _c('form-review', {
    attrs: {
      "title": _vm.title,
      "rating": _vm.rating,
      "userData": _vm.userData,
      "errorText": _vm.reviewError,
      "buttonText": _vm.formBtnText,
      "localReview": _vm.localReview,
      "placeholderText": _vm.placeholderText,
      "errorValidationText": _vm.errorValidationText
    },
    on: {
      "submit": _vm.submitReview
    }
  }) : _vm._e()], 1) : _vm._e(), (!_vm.auth) ? _c('p', {
    staticClass: "reviews__text"
  }, [_vm._v("Оставить " + _vm._s(_vm.blog ? 'комментарий' : 'отзыв') + " могут только зарегистрированные пользователи.")]) : _vm._e(), _c('div', {
    staticClass: "reviews__btn"
  }, [_c('ext-button', {
    attrs: {
      "color": 'default',
      "size": 'small',
      "factor": 1.4,
      "wide": true,
      "fill": _vm.auth
    },
    on: {
      "click": _vm.eventComp
    }
  }, [_vm._v(_vm._s(!_vm.auth ? _vm.authText : _vm.text))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4400b226","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/reviews/Reviews.vue
// module id = ca0141e255a7a6d00e8a
// module chunks = 0